import './savingsNotification.scss';
import {AbstractNotificationComponent} from "../AbstractNotificationComponent";

export class SavingsNotification extends AbstractNotificationComponent {

    static instance = {
        template: require('./savingsNotification.html'),
        controller: ['$scope', '$location', SavingsNotification],
        bindings: {
            'notification': '<'
        }
    };

}